var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _vm.isShowHeading
      ? _c("div", { class: _vm.prefixClass + "__heading" }, [
          _c("div", { class: _vm.prefixClass + "__title" }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
          ]),
          _vm._v(" "),
          _vm.isShowAction
            ? _c(
                "div",
                { class: _vm.prefixClass + "__action" },
                [_vm._t("action")],
                2
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { class: _vm.prefixClass + "__body" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c9bf04e", { render: render, staticRenderFns: staticRenderFns })
  }
}